import { ButtonLounge } from 'app/shared/components/common/button/button-louge';
import { InputLounge } from 'app/shared/components/common/input/lounge-input';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { getUserInfoSelector } from 'app/modules/contract/service/store/selectors';
import './style.scss';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';

export interface IConfirmationMail {
  setData: any;
  contactData: any;
}
const ConfirmationMail = ({ setData, contactData }: IConfirmationMail) => {
  // const [contact, setContact] = useState(setData || {})
  
 

  const history = useHistory();
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const userInfo: any = useSelector<IRootState>(getUserInfoSelector);
  const [email, setEmail] = useState(userInfo?.email);

  const handleChangeEmail = value => {
    setEmail(value);
  };
  return (
    <>
      <AvatarWithBadge
        avatar={avatar}
        getPreviousStep={() => {
          setData('viewId', 'form_contact');
        }}
      />
      <div className="confirmation_mail_title">{`Adresse email pour la réponse`}</div>

      <div className="input-mail">
      
        <InputLounge value={email} style={'info-client-input'} label={'email'} placeholder={'email'} action={e => handleChangeEmail(e.target.value)} />
      </div>
      <div className="button-container">
        <ButtonLounge
          title={'ENVOYER'}
          action={() => {
            setData('viewId', 'confirmation_contact');
          }}
          style={5}
        />
      </div>
    </>
  );
};

export default ConfirmationMail;
